/* eslint-disable import/no-cycle */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';
import { BANK_TRANSFER, PAYPAL } from '../../config/constants';
import Button from '../Button/Button';
import PayPalForm from '../PayPalForm/PayPalForm';
import PaymentTypeLabel from '../PaymentTypeLabel/PaymentTypeLabel';


class PayPal extends React.Component {
  state = {
    isShowUpdateMessage: false,
  };

  onUpdate = () => {
    this.setState({ isShowUpdateMessage: true });
    this.props.onSubmit();
  }

  renderEditFields = (classes, paymentIndex, updateStatus, confirmStatus) => (
    <div>
      <PayPalForm />
      {!paymentIndex
        && (
          <div>
            {this.state.isShowUpdateMessage
              && (
                <div>
                  {(!confirmStatus.Success && updateStatus.status === null)
                    && (
                      <h6 className={classNames(
                        classes.updateText,
                        classes.rejectedColor
                      )}
                      >
                        {confirmStatus.Message}
                      </h6>
                    )}
                  {updateStatus.status !== null
                    && (
                      <h6 className={classNames(
                        classes.updateText,
                        !updateStatus.status ? classes.rejectedColor : ''
                      )}
                      >
                        {updateStatus.payment}
                      </h6>
                    )}
                </div>
              )}
            <Button
              text={'update'}
              onPress={this.onUpdate}
              style={classes.submitButton}
            />
          </div>
        )}
    </div>
  );

  render() {
    const {
      classes,
      selectedPaymentType,
      setPaymentType,
      paymentIndex,
      updateStatus,
      confirmStatus,
    } = this.props;

    return (
      <PaymentTypeLabel
        type={PAYPAL}
        selectedPaymentType={selectedPaymentType}
        setPaymentType={setPaymentType}
        paymentIndex={paymentIndex}
        renderPaymentTypeInfo={
          this.renderEditFields(classes, paymentIndex, updateStatus, confirmStatus)
        }
      />
    );
  }
}

PayPal.propTypes = {
  classes: PropTypes.object,
  selectedPaymentType: PropTypes.number,
  setPaymentType: PropTypes.func,
  paymentIndex: PropTypes.bool,
  updateStatus: PropTypes.object,
  confirmStatus: PropTypes.object,
  onSubmit: PropTypes.func,
};

PayPal.defaultProps = {
  classes: {},
  selectedPaymentType: BANK_TRANSFER,
  setPaymentType: () => { },
  paymentIndex: true,
  updateStatus: {},
  confirmStatus: {},
  onSubmit: () => { },
};

export default withStyles(styles)(PayPal);
